var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvalidLinks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_4194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3262 26.3267H43.8499V30.7471H25.3262V26.3267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3262 35.9194H43.8499V40.3399H25.3262V35.9194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3262 45.5122H35.7147V49.9327H25.3262V45.5122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9999 60.6489L58.9853 53.6344L65.9969 46.6228L60.6489 41.2748L53.6373 48.2864L46.6243 41.2734L41.2734 46.6243L48.2864 53.6373L41.2749 60.6488L46.6229 65.9968L53.6344 58.9853L60.6489 65.9998L65.9999 60.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4205 20.4205H48.1583V37.6444L52.5787 41.9752V16H16V66H41.1799L36.815 61.5796H20.4205V20.4205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_4194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidLinks);
export default __webpack_public_path__ + "static/media/Invalid_Links.600515775b5924f28c4d38dcc4e25bc5.svg";
export { ForwardRef as ReactComponent };